import axios from "axios";
import { Notyf } from "notyf";
import router from "../router";
import store from "../store";
import "notyf/notyf.min.css";

let duration = 5000;
const notyf = new Notyf();

function removeEmptyFields(data) {
  if (typeof data === "object" && data !== null) {
    if (Array.isArray(data)) {
      // If data is an array, recursively process each element in the array
      const cleanedArray = data.map(item => removeEmptyFields(item));
      return cleanedArray.filter(
        item => item !== null && item !== "" && item !== 0
      );
    } else {
      // If data is an object, recursively process each key-value pair
      const cleanedObject = {};
      for (const key in data) {
        if (key !== "order") {
          const cleanedValue = removeEmptyFields(data[key]);
          if (
            cleanedValue !== null &&
            cleanedValue !== "" &&
            cleanedValue !== 0
          ) {
            cleanedObject[key] = cleanedValue;
          }
        } else {
          cleanedObject[key] = data[key];
        }
      }
      return cleanedObject;
    }
  }

  return data;
}

let baseURL = "";
if (window.location.hostname === "localhost") {
  baseURL = "https://admin.mintgamingapi.com";
} else {
  baseURL = `https://admin.${window.location.hostname}`;
}

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json"
  }
});

// Add the interceptor
api.interceptors.request.use(config => {
  // remove all the empty fields from the request
  if (
    config.headers.hasOwnProperty("Content-Type") &&
    config.headers["Content-Type"] !== "multipart/form-data"
  )
    config.data = removeEmptyFields(config.data);

  // Add the Authorization header with the Bearer token
  const token = sessionStorage.getItem("token");
  if (token) config.headers["Authorization"] = token;
  return config;
});

function showErrorNotification(message) {
  notyf.error({
    duration,
    dismissible: true,
    position: { x: "right", y: "top" },
    message
  });
}

api.interceptors.response.use(
  response => response,
  error => {
    const { response } = error;

    if (response) {
      const { status, data } = response;

      switch (status) {
        case 401:
          if (response.config.url.includes("sessions")) {
            showErrorNotification("Wrong credentials.");
          } else {
            // Unauthorized
            console.log(store.dispatch("logout"));
            store.dispatch("logout");
          }
          break;
        case 422:
          // Unprocessable entity
          let errorString =
            "Validation Errors: " +
            Object.keys(data)
              .map(key => `${key} ${data[key].join(", ")}`)
              .join(", ");
          if (errorString) showErrorNotification(errorString);
          else showErrorNotification("Unprocessable entity.");
          break;
        case 403:
          // Forbidden
          showErrorNotification("Forbidden.");
          break;
        case 404:
          // Not found
          showErrorNotification("Endpoint not found.");
          break;
        case 500:
          // Internal server error
          showErrorNotification("Internal server error.");
          break;
        default:
          // Other errors
          let message = "";
          if (data && data.message) message = data.message;
          else message = error.message;
          showErrorNotification(message);
          break;
      }

      return Promise.reject(false);
    }

    console.error("Network Error:", error.message);

    showErrorNotification("Network error occurred.");

    return Promise.reject(error);
  }
);

export default api;



// WEBPACK FOOTER //
// ./src/lib/api.js